module.exports = __webpack_public_path__ + "static/media/kitty-cat_zoom.dab37045.gif";